import { useApiQuery } from '../useApi';
import { BRAND_ID } from '../../config/brand';

export interface BrandLanguage {
  name: string;
  lang: string;
}

export interface BrandSocial {
  icon: string;
  link: string;
  name: string;
}

export interface Brand {
  _id: string;
  name: string;
  code: string;
  hostname?: string;
  languages: BrandLanguage[];
  socials: BrandSocial[];
  createdAt: string;
  updatedAt: string;
}

export const useGetBrand = () => {
  const {
    data: brand,
    isFetching,
    isSuccess,
    error,
  } = useApiQuery<Brand>(
    `/brands/${BRAND_ID}`,
    ['brand', BRAND_ID],
    undefined,
    { enabled: !!BRAND_ID, staleTime: 60 * 60 * 1000, gcTime: 60 * 60 * 1000 },
  );

  return { brand, isFetching, isSuccess, error };
};
